/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-30 14:45:25
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-10-13 17:00:26
 * @FilePath: \bee-transport-h5-v1.0.3d:\project\mobile-map\src\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    // redirect: '/dispatch'
    // redirect:'/dispatch-car-location'
    redirect:'/404'
  },
  {
    path:'/404',
    component: () => import('./view/error/404.vue'),
    meta:{
      title:'找不到页面'
    }
  },
  {
    name: 'dispatch',
    component: () => import('./view/dispatch'),
    meta: {
      title: '调度地址簿地图'
    }
  },
  {
    name: 'dispatchSelectAddress',
    component: () => import('./view/dispatchSelectAddress'),
    meta: {
      title: '确认地址'
    }
  },
  {
    name: 'dispatchHuaqin',
    component: () => import('./view/dispatchHuaqin'),
    meta: {
      title: '编辑地址'
    }
  },
  {
    path:'/dispatch/orderTrack',
    name: 'orderTrack',
    component: () => import('./view/dispatch/orderTrack'),
    meta: {
      title: '地图轨迹'
    }
  },
  {
    path: '/dispatch/huaqinFilesUpload',
    component: () => import('./view/dispatch/huaqinFilesUpload'),
    meta: {
      title: '文件上传'
    }
  },
  {
    name: 'line',
    component: () => import('./view/line'),
    meta: {
      title: '线路地图'
    }
  },
  {
    name: 'dispatch-car-location',
    component: () => import('./view/dispatch-car-location'),
    meta: {
      title: ''
    }
  },
  {
    path: '/beecargo/nanahangAddressBook',
    component: () => import('./view/beecargo/nanahangAddressBook'),   // 南航H5应用
    meta: {
      title: '南航新增卸货地'
    }
  },
  {
    path: '/beecargo/nanhangAppAddressBook',
    component: () => import('./view/beecargo/nanhangAppAddressBook'),  // 南航app应用
    meta: {
      title: '南航新增卸货地'
    }
  },
  {
    path: '/beecargo/addressBook',
    component: () => import('./view/beecargo/addressBook'),
    meta: {
      title: '地图选址'
    }
  },
  {
    path: '/beecargo/customerService',
    component: () => import('./view/beecargo/customerService'),
    meta: {
      title: '联系客服'
    }
  },
  {
    path: '/beecargo/logisticsDetails',
    component: () => import('./view/beecargo/logisticsDetails'),
    meta: {
      title: '查看物流',keepAlive: true
    }
  },
  {
    path: '/beecargo/logisticsDetails/pickedUp',
    component: () => import('./view/beecargo/logisticsDetails/pickedUp'),
    meta: {
      title: '查看物流'
    }
  },
  {
    path: '/beecargo/loadingUnloadingChargingRules',
    component: () => import('./view/beecargo/loadingUnloadingChargingRules'),
    meta: {
      title: '装卸搬运收费规则'
    }
  },
  {
    path: '/beecargo/importAndExportFilesUpload',
    component: () => import('./view/beecargo/importAndExportFilesUpload'),
    meta: {
      title: '进出口文件上传'
    }
  },
  {
    path:'/baiduAI/index',
    component: () => import('./view/baiduAI'),
    meta:{
      title:'实名认证'
    }
  },
  {
    path:'/baiduAI/success',
    component: () => import('./view/baiduAI/success'),
    meta:{
      title:'认证成功'
    }
  },
  {
    path:'/baiduAI/failed',
    component: () => import('./view/baiduAI/failed'),
    meta:{
      title:'认证失败'
    }
  },
  {
    path:'/driverBaiduAI/index',
    component: () => import('./view/driverBaiduAI'),
    meta:{
      title:'实名认证'
    }
  },
  {
    path:'/driverBaiduAI/success',
    component: () => import('./view/driverBaiduAI/success'),
    meta:{
      title:'认证成功'
    }
  },
  {
    path:'/driverBaiduAI/failed',
    component: () => import('./view/driverBaiduAI/failed'),
    meta:{
      title:'认证失败'
    }
  },
  {
    path: '/salesperson/lineProvidePricing',
    component: () => import('./view/salesperson/lineProvidePricing'),
    meta: {
      title: '线路信息'
    }
  },
{
    path: '/salesperson/salePay',
    component: () => import('./view/salesperson/salePay'),
    meta: {
      title: '订单详情'
    }
  },
 {
    path: '/salesperson/addressBook',
    component: () => import('./view/salesperson/addressBook'),
    meta: {
      title: '地址簿'
    }
  },
  {
    path: '/salesperson/personCode',
    component: () => import('./view/salesperson/personCode'),
    meta: {
      title: '个人专属二维码'
    }
  },
  {
    path: '/salesperson/saleCoupon',
    component: () => import('./view/salesperson/sale-coupon'),
    meta: {
      title: '优惠券详情'
    }
  },
  {
    path: '/agreements/salesman/sdk',
    component: () => import('./view/agreements/salesman/sdk'),
    meta: {
      title: 'Android APP 第三方SDK列表'
    }
  },
  {
    path: '/agreements/driver/sdk',
    component: () => import('./view/agreements/driver/sdk'),
    meta: {
      title: 'Android APP 第三方SDK列表'
    }
  },
  {
    path: '/agreements/beecargo/sdk',
    component: () => import('./view/agreements/beecargo/sdk'),
    meta: {
      title: 'Android APP 第三方SDK列表'
    }
  },
  {
    path: '/taskBar/addTaskFilesUpload',
    component: () => import('./view/taskBar/addTaskFilesUpload'),
    meta: {
      title: '文件上传'
    }
  },{
    path: '/androidDriverFloatingWindow',
    component: () => import('./view/driver-floating-android-window/index'),
    meta: {
      title: '悬浮窗'
    }
  },{
    path: '/iosDriverFloatingWindow',
    component: () => import('./view/driver-floating-ios-window/index'),
    meta: {
      title: '悬浮窗'
    }
  },{
    path: '/driver/cancelOrderRules',
    component: () => import('./view/driver/cancelOrderRules'),
    meta: {
      title: '取消订单规则'
    }
  },{
    path: '/beecargo/cancelOrderRules',
    component: () => import('./view/beecargo/cancelOrderRules/index'),
    meta: {
      title: '退款规则'
    }
  },{
    path: '/beecargo/couponRules',
    component: () => import('./view/beecargo/couponRules/index'),
    meta: {
      title: '优惠券规则说明'
    }
  },{
    path:'/dispatchImportAndExport/filesUpload',
    component: () => import('./view/dispatchImportAndExport/filesUpload'),
    meta: {
      title: '上传附件'
    }
  },{
    path:'/material/materialDataUpload',
    component: () => import('./view/material/materialDataUpload'),
    meta: {
      title: '领料数据上传',
      keepAlive: true
    }
  },{
    path:'/material/warehouseMapList',
    component: () => import('./view/material/warehouseMapList'),
    meta: {
      title: '',
    }
  },{
    path:'/material/materialDataUpload/addEdit',
    component: () => import('./view/material/materialDataUpload/addEdit'),
    meta: {
      title: '',
      keepAlive: true,
    }
  },{
    path:'/material/materialDataUpload/generatedSuccess',
    component: () => import('./view/material/materialDataUpload/generatedSuccess'),
    meta: {
      title: '领料任务生成完成'
    }
  },{
    path: '/material/addressBook',
    component: () => import('./view/material/addressBook'),
    meta: {
      title: '地址簿'
    }
  },{
    path: '/material/checkIn',
    component: () => import('./view/material/checkIn'),
    meta: {
      title: '签到'
    }
  },{
    path:'/dispatchImportAndExport/logisticsNode',
    component: () => import('./view/dispatchImportAndExport/logisticsNode'),
    meta: {
      title: '查看物流'
    }
  },{
    path:'/dispatchImportAndExport/orderContainerTable',
    component: () => import('./view/dispatchImportAndExport/orderContainerTable'),
    meta: {
      title: '货柜信息'
    }
  },{
    path:'/system/previewPage',
    component: () => import('./view/system/preview-page'),
    meta: {
      title: '图片预览'
    }
  },{
    path:'/salesperson/contractFilesUpload',
    component: () => import('./view/salesperson/contractFilesUpload'),
    meta: {
      title: '上传附件'
    }
  },{
    path: '/driver/notesOnReporting',
    component: () => import('./view/driver/notesOnReporting'),
    meta: {
      title: '举报注意事项'
    }
  },{
    path: '/driver/reportLocation',
    component: () => import('./view/driver/reportLocation'),
    meta: {
      title: '选择地址'
    }
  },{
    path: '/beecargo/autoCarFeeRules',
    component: () => import('./view/beecargo/autoCarFeeRules'),
    meta: {
      title: '收费规则'
    }
  },{
    path: '/beecargo/prohibitedGoodsAgreement',
    component: () => import('./view/beecargo/prohibitedGoodsAgreement'),
    meta: {
      title: '违禁品清单'
    }
  },{
    path: '/beecargo/cancelAutoCarOrderRules',
    component: () => import('./view/beecargo/cancelAutoCarOrderRules'),
    meta: {
      title: '取消订单收费规则'
    }
  },{
    path: '/beecargo/autoCarOrderDetails',
    component: () => import('./view/beecargo/autoCarOrderDetails'),
    meta: {
      title: '查看物流'
    }
  },{
    path: '/driverlessVehicle/vehicleCargoOp',
    component: () => import('./view/beecargo/driverlessVehicle/vehicleCargoOp'),
    meta: {
      title: '小蜂蜂无人车'
    }
  }];
  

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  // window.console.log('beforeEach to',window.location.href,to.fullPath);
  // window.console.log('beforeEach from',from.fullPath)
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
